var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"guide"}},[_c('div',{staticClass:"admin_main_block"},[_c('div',{staticClass:"user_temp_title"},[_vm._v(_vm._s(_vm.article[0].title))]),_vm._v(" "),_c('div',{staticClass:"admin_table_main",domProps:{"innerHTML":_vm._s(_vm.article[0].content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }